import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import './styles.css';
import SimplePanelHeading from '../../../interfaces/simple/SimplePanelHeading';

function SoldInfo() {
  const [range, setRange] = useState('all');

  const RANGE_OPTIONS = [
    { label: '7D', value: '7d' },
    { label: '30D', value: '30d' },
    { label: 'YTD', value: 'ytd' },
    { label: 'All', value: 'all' },
  ];

  const [profit, setProfit] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/profit', { params: { range } })
      .then((response) => {
        setProfit(response.data[0].TotalProfit ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching profit: ${error}`);
      });
  }, [range]);

  const [cost, setCost] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/cost', { params: { range } })
      .then((response) => {
        setCost(response.data[0].TotalCost ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching cost: ${error}`);
      });
  }, [range]);

  const [soldPrice, setSoldPrice] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/price', { params: { range } })
      .then((response) => {
        setSoldPrice(response.data[0].TotalSoldPrice ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching sold price: ${error}`);
      });
  }, [range]);

  const [soldCount, setSoldCount] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/count', { params: { range } })
      .then((response) => {
        setSoldCount(response.data[0].TotalSoldCount ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching sold count: ${error}`);
      });
  }, [range]);

  const [soldFeeGrade, setSoldFeeGrade] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/card_fee_grade', { params: { range } })
      .then((response) => {
        setSoldFeeGrade(response.data[0].SoldFeeGrade ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching grade fees: ${error}`);
      });
  }, [range]);

  const [soldFeeShip, setSoldFeeShip] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/card_solds_ship', { params: { range } })
      .then((response) => {
        setSoldFeeShip(response.data[0].SoldFeeShip ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching shipping fees: ${error}`);
      });
  }, [range]);

  const [soldFee, setSoldFee] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/card_sold_fees', { params: { range } })
      .then((response) => {
        setSoldFee(response.data[0].SoldFee ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching selling fees: ${error}`);
      });
  }, [range]);

  const [soldFeeAds, setSoldFeeAds] = useState(0);
  useEffect(() => {
    Axios.get('https://api.alientrader.cards/sold/card_sold_fees_ads', { params: { range } })
      .then((response) => {
        setSoldFeeAds(response.data[0].SoldFeeAds ?? 0);
      })
      .catch((error) => {
        console.error(`Error fetching ad fees: ${error}`);
      });
  }, [range]);

  const salesMinusFees =
    (Number(soldPrice) || 0) -
    (Number(soldFee) || 0) -
    (Number(soldFeeShip) || 0) -
    (Number(soldFeeAds) || 0);

  return (
    <Col xs={5} sm={5} md={4} lg={3} xl={3} className="info-box shadow-sm" data-dashboard-metric="sold">
      <Row><div className="info-header"><SimplePanelHeading kind="sold">Sold Info</SimplePanelHeading></div></Row>

      <Row className="justify-content-end mb-1">
        <Col xs="12" className="d-flex justify-content-end">
          <div className="info-range-toggle">
            {RANGE_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                type="button"
                className={`info-range-btn ${range === opt.value ? 'active' : ''}`}
                onClick={() => setRange(opt.value)}
                aria-pressed={range === opt.value}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={6}><div className="info-title">Cards Sold:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">{soldCount.toLocaleString()}</div>
        </Col>
      </Row>
      <Row>
        <Col xs={6}><div className="info-title">Profit:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value" data-positive={Number(profit) > 0}>
            {profit.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6}><div className="info-title">Total Sales:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {soldPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6}><div className="info-title">Total Cost:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {cost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6}><div className="info-title">Grading Cost:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {soldFeeGrade.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6}><div className="info-title">Shipping Fees:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {soldFeeShip.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className="info-title">Selling Fees:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {soldFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className="info-title">Selling Ad Fees:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {soldFeeAds.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col><div className="info-title">Sales - Fees:</div></Col>
        <Col className="d-flex align-items-center justify-content-center">
          <div className="info-value">
            {salesMinusFees.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export default SoldInfo;
